var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("b-loading", {
        attrs: {
          "is-full-page": _vm.isFullPage,
          active: _vm.isLoading,
          "can-cancel": true
        },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sidebar sidebar-fixed bg-white",
          attrs: { id: "sidebarMenu" }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sidebar-body" },
            [
              _vm._l(_vm.inputSearchForms, function(form, i) {
                return form.division === "C"
                  ? _c("ul", { staticClass: "sidebar-nav" }, [
                      i === 0
                        ? _c("li", { staticClass: "nav-label mg-b-10-f" }, [
                            _vm._v(" ")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          {
                            staticClass: "d-block has-text-weight-semibold",
                            attrs: { for: form.id }
                          },
                          [_vm._v(_vm._s(form.name))]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "mg-b-0 text-left" }, [
                          _vm._v(_vm._s(_vm.experimentData[form.id]))
                        ])
                      ])
                    ])
                  : form.division === "O"
                  ? _c("ul", { staticClass: "sidebar-nav" }, [
                      i === 0
                        ? _c("li", { staticClass: "nav-label mg-b-10-f" }, [
                            _vm._v(" ")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          {
                            staticClass: "d-block has-text-weight-semibold",
                            attrs: { for: "formGroupExampleInput" }
                          },
                          [_vm._v(_vm._s(form.name))]
                        ),
                        _vm._v(" "),
                        form.value.length > 0
                          ? _c(
                              "p",
                              { staticClass: "mg-b-0 text-left" },
                              _vm._l(form.value, function(form1, i) {
                                return form1.codeCode ==
                                  _vm.experimentData[form.id]
                                  ? _c("span", [_vm._v(_vm._s(form1.codeName))])
                                  : _vm._e()
                              }),
                              0
                            )
                          : _c("p", { staticClass: "mg-b-0 text-left" }, [
                              _vm._v(_vm._s(_vm.experimentData[form.id]))
                            ])
                      ])
                    ])
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm._l(_vm.checkboxSearchForms, function(form, i) {
                return _c("ul", { staticClass: "sidebar-nav" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: " d-block has-text-weight-semibold",
                          attrs: { for: "formGroupExampleInput" }
                        },
                        [_vm._v(_vm._s(form.name))]
                      ),
                      _vm._v(" "),
                      _vm._l(form.value, function(form1, j) {
                        return _vm.experimentData[form.id] == form1.codeCode
                          ? _c("p", { staticClass: "mg-b-0 text-left" }, [
                              _vm._v(_vm._s(form1.codeName))
                            ])
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ])
              }),
              _vm._v(" "),
              _vm._l(_vm.dateRangeSearchForms, function(form, i) {
                return _c("ul", { staticClass: "sidebar-nav" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      {
                        staticClass: "d-block has-text-weight-semibold",
                        attrs: { for: "formGroupExampleInput" }
                      },
                      [_vm._v(_vm._s(form.name))]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "mg-b-0 text-left" }, [
                      _vm._v(_vm._s(_vm.experimentData[form.id]))
                    ])
                  ])
                ])
              }),
              _vm._v(" "),
              _vm._l(_vm.dateSearchForms, function(form, i) {
                return _c("ul", { staticClass: "sidebar-nav" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      {
                        staticClass: "d-block has-text-weight-semibold",
                        attrs: { for: "formGroupExampleInput" }
                      },
                      [_vm._v(_vm._s(form.name))]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "mg-b-0 text-left" }, [
                      _vm._v(_vm._s(_vm.experimentData[form.id]))
                    ])
                  ])
                ])
              })
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "content content-components overflow-hidden" }, [
        _c("div", { staticClass: "pd-x-0 pd-lg-x-10 pd-xl-x-0" }, [
          _c(
            "div",
            {
              staticClass:
                "d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30"
            },
            [
              _c("div", [
                _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
                  _c(
                    "ol",
                    { staticClass: "breadcrumb breadcrumb-style1 mg-b-10" },
                    [
                      _c("li", { staticClass: "breadcrumb-item" }, [
                        _vm._v(_vm._s(this.mainName))
                      ]),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass: "breadcrumb-item",
                          attrs: { "aria-current": "page" }
                        },
                        [_vm._v(_vm._s(this.subName))]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass: "breadcrumb-item active",
                          attrs: { "aria-current": "page" }
                        },
                        [_vm._v("View")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "mg-b-0 tx-spacing--1" }, [
                    _vm._v(_vm._s(this.subName) + " View")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "card-header2 col-lg-8 col-xl-7 pd-y-15 pd-x-20 d-flex align-items-center justify-content-end"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5",
                      on: {
                        click: function($event) {
                          return _vm.reportEditor()
                        }
                      }
                    },
                    [
                      _c("feather", {
                        staticClass:
                          "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                        attrs: { type: "printer" }
                      }),
                      _vm._v("Report")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass:
                        "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5",
                      attrs: {
                        to: {
                          name: this.$route.name.replace("_completion", ""),
                          params: { mid: this.properties.mid, type: "list" }
                        }
                      }
                    },
                    [
                      _c("feather", {
                        staticClass:
                          "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                        attrs: { type: "file" }
                      }),
                      _vm._v("list")
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: " pd-x-0 pd-lg-x-10 pd-xl-x-0" }, [
            _c("div", { staticClass: "col-sm-6 col-lg-5 d-inline-block" }, [
              _c(
                "ul",
                {
                  staticClass: "cardborder nav nav-tabs",
                  attrs: { id: "myTab", role: "tablist" }
                },
                [
                  _c("li", { staticClass: "nav-item" }, [
                    _c(
                      "a",
                      {
                        staticClass: "nav-link active",
                        attrs: {
                          id: "experiment-tab",
                          "data-toggle": "tab",
                          href: "#experiment",
                          role: "tab",
                          "aria-controls": "experiment",
                          "aria-selected": "true"
                        },
                        on: {
                          click: function($event) {
                            return _vm.classifyData()
                          }
                        }
                      },
                      [_vm._v("Experiment")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "nav-item" }, [
                    _c(
                      "a",
                      {
                        staticClass: "nav-link",
                        attrs: {
                          id: "reexperiment-tab",
                          "data-toggle": "tab",
                          href: "#reexperiment",
                          role: "tab",
                          "aria-controls": "reexperiment",
                          "aria-selected": "false"
                        },
                        on: {
                          click: function($event) {
                            return _vm.classifyReExpData()
                          }
                        }
                      },
                      [_vm._v("ReExperiment")]
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-inline-block",
                staticStyle: {
                  "max-width": "57%",
                  width: "100%",
                  "text-align": "right"
                }
              },
              [
                this.downloadList.QC.length > 0
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-xs pd-x-15 btn-info btn-uppercase mg-l-5-f",
                        on: {
                          click: function($event) {
                            return _vm.reportDialogHandler()
                          }
                        }
                      },
                      [
                        _c("feather", {
                          staticClass:
                            "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                          attrs: { type: "file-text" }
                        }),
                        _vm._v("QC_Report")
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.imgData.length > 0
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-xs pd-x-15 btn-info btn-uppercase mg-l-5-f",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": "#ViewGel"
                        }
                      },
                      [
                        _c("feather", {
                          staticClass:
                            "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                          attrs: { type: "image" }
                        }),
                        _vm._v("Gel")
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "gel-container" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "cart" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            { name: "draggable", rawName: "v-draggable" }
                          ],
                          staticClass: "items-list collapse",
                          staticStyle: { "max-width": "1500px" },
                          style: {
                            width:
                              _vm.imgData.length * 180 +
                              _vm.imgData.length * 20 +
                              "px"
                          },
                          attrs: { id: "ViewGel" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "white-space": "nowrap",
                                "overflow-x": "scroll"
                              }
                            },
                            [
                              _c("imageViewerConfirm", {
                                attrs: { image: _vm.imgData }
                              }),
                              _vm._v(" "),
                              _vm._m(1)
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._m(2)
                        ]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm.nanoData.length > 0
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-xs pd-x-15 btn-info btn-uppercase mg-l-5-f",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": "#ViewNano"
                        }
                      },
                      [
                        _c("nanoIcon", {
                          staticClass: "wd-15 hd-15 mg-r-5 ",
                          attrs: { fill: "white" }
                        }),
                        _vm._v("NANO DROP")
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "gel-container" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "cart" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            { name: "draggable", rawName: "v-draggable" }
                          ],
                          staticClass: "items-list collapse",
                          staticStyle: { "max-width": "1500px" },
                          style: {
                            width:
                              _vm.nanoData.length * 180 +
                              _vm.nanoData.length * 20 +
                              "px"
                          },
                          attrs: { id: "ViewNano" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "white-space": "nowrap",
                                "overflow-x": "scroll"
                              }
                            },
                            [
                              _c("nanoViewerConfirm", {
                                attrs: { image: _vm.nanoData }
                              }),
                              _vm._v(" "),
                              _vm._m(3)
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._m(4)
                        ]
                      )
                    ])
                  ])
                ]),
                _vm._v("\n\t\t\t\t\t\t    \n\t\t\t\t\t\t"),
                _vm.tapeData.length > 0
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-xs pd-x-15 btn-info btn-uppercase mg-l-5-f",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": "#ViewTape"
                        }
                      },
                      [
                        _c("tapeIcon", {
                          staticClass: "wd-15 hd-15 mg-r-5 ",
                          attrs: { fill: "white" }
                        }),
                        _vm._v("TAPE STATION")
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "tape-container" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "cart" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            { name: "draggable", rawName: "v-draggable" }
                          ],
                          staticClass: "items-list2 collapse",
                          attrs: { id: "ViewTape" }
                        },
                        [
                          _c("tapeViewerConfirm", {
                            attrs: { image: _vm.tapeData }
                          }),
                          _vm._v(" "),
                          _vm._m(5),
                          _vm._v(" "),
                          _vm._m(6),
                          _vm._v(" "),
                          _vm._m(7)
                        ],
                        1
                      )
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "card card-body pd-b-0-f" }, [
              _c(
                "div",
                {
                  staticClass: "tab-content mg-t-20",
                  attrs: { id: "myTabContent" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "tab-pane fade lm-overflow show active",
                      attrs: {
                        id: "experiment",
                        role: "tabpanel",
                        "aria-labelledby": "experiment-tab"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-none d-md-block tx-right-f mg-xs-y-15-f"
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass:
                                "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5",
                              attrs: {
                                href: "",
                                "data-toggle": "modal",
                                "data-animation": "effect-flip-horizontal"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.reExpDialogHandler("re-experiment")
                                }
                              }
                            },
                            [
                              _c("feather", {
                                staticClass:
                                  "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                attrs: { type: "minus" }
                              }),
                              _vm._v("re-experiment")
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          staticClass: "nav nav-line",
                          attrs: { id: "myTab5", role: "tablist" }
                        },
                        _vm._l(_vm.tabHeader, function(form, i) {
                          return _vm.properties.mid === form.id
                            ? _c("li", { staticClass: "nav-item" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link active",
                                    attrs: {
                                      id: form.id,
                                      "data-toggle": "tab",
                                      href: "#",
                                      role: "tab",
                                      "aria-controls": "home",
                                      "aria-selected": "true"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.classifySampleHeader(
                                          form.id,
                                          _vm.tabHeader.length,
                                          i
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(form.menuName))]
                                )
                              ])
                            : _c("li", { staticClass: "nav-item" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link",
                                    attrs: {
                                      id: form.id,
                                      "data-toggle": "tab",
                                      href: "#",
                                      role: "tab",
                                      "aria-controls": "profile",
                                      "aria-selected": "false"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.classifySampleHeader(
                                          form.id,
                                          _vm.tabHeader.length,
                                          i
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(form.menuName))]
                                )
                              ])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "card col-lg-8 col-xl-7 mg-b-20 mg-lg-b-25"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-none d-md-block tx-right-f" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 mg-y-9-f",
                                  attrs: {
                                    href: "",
                                    "data-toggle": "modal",
                                    "data-animation": "effect-flip-horizontal"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.checkedRows = _vm.sampleData.filter(
                                        function(sample) {
                                          return (
                                            sample.experimentResultcode ==
                                            "Fail"
                                          )
                                        }
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("feather", {
                                    staticClass:
                                      "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                    attrs: { type: "plus" }
                                  }),
                                  _vm._v("fail-check")
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 mg-y-9-f",
                                  attrs: {
                                    href: "",
                                    "data-toggle": "modal",
                                    "data-animation": "effect-flip-horizontal"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.excelExport()
                                    }
                                  }
                                },
                                [
                                  _c("feather", {
                                    staticClass:
                                      "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                    attrs: { type: "file-text" }
                                  }),
                                  _vm._v("Excel")
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "section",
                            [
                              _c(
                                "b-table",
                                {
                                  ref: "table",
                                  staticClass:
                                    "overflow-x-hidden b-table-fix-header",
                                  attrs: {
                                    id: "btable",
                                    data: _vm.isEmpty ? [] : _vm.sampleData,
                                    "checked-rows": _vm.checkedRows,
                                    checkable: "",
                                    hoverable: "",
                                    striped: ""
                                  },
                                  on: {
                                    "update:checkedRows": function($event) {
                                      _vm.checkedRows = $event
                                    },
                                    "update:checked-rows": function($event) {
                                      _vm.checkedRows = $event
                                    }
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function(props) {
                                        return _vm._l(
                                          _vm.sampleHeader,
                                          function(form, i) {
                                            return i == 0
                                              ? _c(
                                                  "b-table-column",
                                                  {
                                                    key: i,
                                                    attrs: {
                                                      field: "No",
                                                      label: "No"
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(props.row.no))]
                                                )
                                              : Number(i) == 1
                                              ? _c(
                                                  "b-table-column",
                                                  {
                                                    key: form.id,
                                                    attrs: {
                                                      "custom-key": form.id,
                                                      field: form.columnCode,
                                                      label: form.columnName,
                                                      centered: "",
                                                      sortable: ""
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: "#modal5",
                                                          id: props.index,
                                                          "data-toggle":
                                                            "modal",
                                                          "data-animation":
                                                            "effect-flip-horizontal"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.sendId(
                                                              props.row.id
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              props.row[
                                                                form.columnCode
                                                              ]
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "b-table-column",
                                                  {
                                                    key: i,
                                                    attrs: {
                                                      field: form.columnCode,
                                                      label: form.columnName,
                                                      centered: "",
                                                      sortable: ""
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        props.row[
                                                          form.columnCode
                                                        ]
                                                      )
                                                    )
                                                  ]
                                                )
                                          }
                                        )
                                      }
                                    }
                                  ])
                                },
                                [
                                  _vm._v(" "),
                                  _c("template", { slot: "empty" }, [
                                    _c("section", { staticClass: "section" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "content has-text-grey has-text-centered"
                                        },
                                        [_c("p", [_vm._v("Nothing here.")])]
                                      )
                                    ])
                                  ])
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "tab-pane fade",
                      attrs: {
                        id: "reexperiment",
                        role: "tabpanel",
                        "aria-labelledby": "reexperiment-tab"
                      }
                    },
                    [
                      _c("ul", {
                        staticClass: "nav nav-line mg-b-0-f",
                        attrs: { id: "myTab5", role: "tablist" }
                      }),
                      _vm._v(" "),
                      _c(
                        "section",
                        [
                          _c(
                            "b-table",
                            {
                              ref: "table",
                              attrs: {
                                id: "preTable",
                                data: _vm.isEmpty ? [] : _vm.reExpData,
                                striped: "",
                                detailed: "",
                                paginated: "",
                                "per-page": "15",
                                "detail-key": "id",
                                "show-detail-icon": false,
                                "opened-detailed": _vm.defaultOpenedDetails
                              },
                              on: {
                                "details-open": function(row, index) {
                                  return _vm.closeAllOtherToggle(row, index)
                                }
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(props) {
                                    return _vm._l(_vm.reExpHeader, function(
                                      form,
                                      i
                                    ) {
                                      return Number(i) == 1
                                        ? _c(
                                            "b-table-column",
                                            {
                                              key: form.id,
                                              attrs: {
                                                "custom-key": form.id,
                                                field: form.columnCode,
                                                label: form.columnName,
                                                centered: ""
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "#",
                                                    id: props.index
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toggle(
                                                        props.row,
                                                        _vm.tabHeader[
                                                          _vm.tabHeader.length -
                                                            1
                                                        ].jobOrder
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        props.row[
                                                          form.columnCode
                                                        ]
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _c(
                                            "b-table-column",
                                            {
                                              key: form.id,
                                              attrs: {
                                                "custom-key": form.id,
                                                field: form.columnCode,
                                                label: form.columnName,
                                                centered: ""
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  props.row[form.columnCode]
                                                )
                                              )
                                            ]
                                          )
                                    })
                                  }
                                },
                                {
                                  key: "detail",
                                  fn: function(props) {
                                    return [
                                      _c(
                                        "ul",
                                        {
                                          staticClass: "nav nav-line",
                                          attrs: {
                                            id: "myTab5",
                                            role: "tablist"
                                          }
                                        },
                                        [
                                          _vm._l(_vm.tabHeader, function(
                                            form,
                                            i
                                          ) {
                                            return _c(
                                              "li",
                                              { staticClass: "nav-item" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "nav-link",
                                                    class: {
                                                      active: form.activeNav
                                                    },
                                                    attrs: {
                                                      id: form.id,
                                                      "data-toggle": "tab",
                                                      href: "#",
                                                      role: "tab",
                                                      "aria-controls": "home",
                                                      "aria-selected": "true"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.classifyReExpSamplesData(
                                                          props.row,
                                                          form.jobOrder
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(form.menuName)
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "button is-light",
                                              staticStyle: {
                                                "margin-left": "auto"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.addReExpSamples()
                                                }
                                              }
                                            },
                                            [
                                              _c("feather", {
                                                staticClass:
                                                  "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                                attrs: { type: "plus" }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c("b-table", {
                                        ref: "sampleTable",
                                        attrs: {
                                          id: "preSampleTable",
                                          columns: _vm.reExpSampleColumns,
                                          data: _vm.isEmpty
                                            ? []
                                            : _vm.reExpSampleData,
                                          "checked-rows":
                                            _vm.reSampleCheckedRows,
                                          hoverable: "",
                                          striped: "",
                                          checkable: ""
                                        },
                                        on: {
                                          "update:checkedRows": function(
                                            $event
                                          ) {
                                            _vm.reSampleCheckedRows = $event
                                          },
                                          "update:checked-rows": function(
                                            $event
                                          ) {
                                            _vm.reSampleCheckedRows = $event
                                          }
                                        }
                                      })
                                    ]
                                  }
                                }
                              ])
                            },
                            [
                              _vm._v(" "),
                              _c("template", { slot: "empty" }, [
                                _c("section", { staticClass: "section" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "content has-text-grey has-text-centered"
                                    },
                                    [_c("p", [_vm._v("Nothing here.")])]
                                  )
                                ])
                              ])
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-none" },
                            [
                              _c("b-table", {
                                ref: "sampleTable",
                                attrs: { id: "preSampleTable" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "df-settings",
                class: { show: _vm.b_sh_well, "": !_vm.b_sh_well }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "df-settings-link closed-cursor text-vertical-3",
                    on: {
                      click: function($event) {
                        return _vm.ptshow()
                      }
                    }
                  },
                  [_vm._v("PLATE")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "df-settings-body" }, [
                  _c("div", { staticClass: "card card-body" }, [
                    _c(
                      "div",
                      { staticClass: "mg-t-10 mg-sm-t-0" },
                      [
                        _c(
                          "h6",
                          {
                            staticClass:
                              "tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-0-f"
                          },
                          [_vm._v("Plate Well")]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.well_plate, function(idx) {
                          return _c(
                            "div",
                            {
                              staticClass: "d-none",
                              attrs: { id: "d-idx-" + idx }
                            },
                            [
                              _c(
                                "ul",
                                { staticClass: "plate-board" },
                                [
                                  _c(
                                    "li",
                                    {
                                      staticClass:
                                        "fl tc w1 plate-list2 mg-t-10-f"
                                    },
                                    [_vm._v("(" + _vm._s(idx) + ")")]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.well_column, function(column) {
                                    return _c(
                                      "li",
                                      {
                                        staticClass:
                                          "fl tc w1 plate-list2 mg-t-10-f"
                                      },
                                      [_vm._v(_vm._s(Number(column)))]
                                    )
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.well_row, function(row) {
                                return _c(
                                  "ul",
                                  { staticClass: "plate-board" },
                                  [
                                    _c(
                                      "li",
                                      {
                                        staticClass:
                                          "fl tc plate-w2 plate-list2 pt-sm-2"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.well_row_a[Number(row) - 1]
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        attrs: { id: "list" + idx + "-" + row }
                                      },
                                      _vm._l(_vm.well_column, function(column) {
                                        return _c(
                                          "li",
                                          {
                                            staticClass:
                                              "fl tc plate-w2 list1 pt-sm-2",
                                            attrs: {
                                              id:
                                                _vm.well_row_a[
                                                  Number(row) - 1
                                                ] + column
                                            }
                                          },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.well_row_a[
                                                    Number(row) - 1
                                                  ]
                                                ) + _vm._s(Number(column))
                                              )
                                            ])
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        })
                      ],
                      2
                    )
                  ])
                ])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "modal5",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "exampleModalLabel5",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered chat-width",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content tx-14 chat-height" }, [
                _vm._m(8),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [_c("Chat")], 1)
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("v-app", { attrs: { id: "inspire" } }, [
        _c(
          "div",
          [
            _c(
              "v-row",
              { attrs: { justify: "center" } },
              [
                _c(
                  "v-dialog",
                  {
                    staticStyle: { "z-index": "20001" },
                    attrs: { "max-width": "500px" },
                    model: {
                      value: _vm.reportDialog,
                      callback: function($$v) {
                        _vm.reportDialog = $$v
                      },
                      expression: "reportDialog"
                    }
                  },
                  [
                    _c(
                      "v-card",
                      [
                        _c("v-card-title", [
                          _vm._v(
                            "\n                            Download Report\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-card-text",
                          [
                            _c("v-select", {
                              attrs: {
                                items: _vm.downloadList["QC"],
                                label: "Select a report",
                                "item-value": "text"
                              },
                              model: {
                                value: _vm.selectReport,
                                callback: function($$v) {
                                  _vm.selectReport = $$v
                                },
                                expression: "selectReport"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-card-actions",
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "secondary", text: "" },
                                on: {
                                  click: function($event) {
                                    _vm.reportDialog = false
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                Close\n                            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "primary", text: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.loadQC_Report()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                Load\n                            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("v-app", { attrs: { id: "inspire" } }, [
        _c(
          "div",
          [
            _c(
              "v-row",
              { attrs: { justify: "center" } },
              [
                _c(
                  "v-dialog",
                  {
                    staticStyle: { "z-index": "20001" },
                    attrs: { "max-width": "500px" },
                    model: {
                      value: _vm.reExpDialog,
                      callback: function($$v) {
                        _vm.reExpDialog = $$v
                      },
                      expression: "reExpDialog"
                    }
                  },
                  [
                    _c(
                      "v-card",
                      [
                        _c("v-card-title", [
                          _vm._v(
                            "\n                                Re-Experiment\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-card-actions",
                          [
                            _c(
                              "v-expand-transition",
                              [
                                _c(
                                  "v-card",
                                  {
                                    staticClass:
                                      "transition-fast-in-fast-out v-card--reveal",
                                    staticStyle: {
                                      height: "100%",
                                      width: "100%"
                                    }
                                  },
                                  [
                                    _c("v-card-text", { staticClass: "pb-0" }, [
                                      _c("div", [
                                        _vm._v("1. Please enter the name.")
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "v-container",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                hint:
                                                  "This field uses experiment name",
                                                label: "Experiment Name"
                                              },
                                              model: {
                                                value: _vm.reExpName,
                                                callback: function($$v) {
                                                  _vm.reExpName = $$v
                                                },
                                                expression: "reExpName"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-card-text", { staticClass: "pb-0" }, [
                                      _c("div", [
                                        _vm._v("2. Please enter the number.")
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "v-container",
                                      [
                                        _c("v-data-table", {
                                          staticClass: "elevation-1",
                                          attrs: {
                                            headers: _vm.reHeaders,
                                            items: this.checkedRows
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "item.qty",
                                              fn: function(props) {
                                                return [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      rules: _vm.qtyRule
                                                    },
                                                    model: {
                                                      value: props.item.qty,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          props.item,
                                                          "qty",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "props.item.qty"
                                                    }
                                                  })
                                                ]
                                              }
                                            }
                                          ])
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-card-actions",
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "primary",
                                              text: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.reExpDialog = false
                                              }
                                            }
                                          },
                                          [_vm._v(" Close ")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "primary",
                                              text: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.reExperiment()
                                              }
                                            }
                                          },
                                          [_vm._v(" Create ")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("v-app", [
        _c(
          "div",
          [
            _c(
              "v-row",
              { attrs: { justify: "center" } },
              [
                _c(
                  "v-dialog",
                  {
                    staticStyle: { "z-index": "20001" },
                    attrs: { "max-width": "290" },
                    model: {
                      value: _vm.confirmDialog,
                      callback: function($$v) {
                        _vm.confirmDialog = $$v
                      },
                      expression: "confirmDialog"
                    }
                  },
                  [
                    _c(
                      "v-card",
                      [
                        [
                          _c("v-card-title", { staticClass: "text-h5" }, [
                            _c("h5", [_vm._v(_vm._s(_vm.dialTitle))])
                          ]),
                          _vm._v(" "),
                          _c("v-card-text", [
                            _c("label", [_vm._v(_vm._s(_vm.dialMsg))])
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-card-actions",
                            [
                              _c("v-spacer"),
                              _vm._v(" "),
                              _vm.dialogBoolean
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "dark", text: "" },
                                          on: {
                                            click: function($event) {
                                              _vm.confirmDialog = false
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    No\n                                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.dialogBoolean
                                        ? _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "dark",
                                                text: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.reExperiment()
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    Yes\n                                "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "dark", text: "" },
                                          on: {
                                            click: function($event) {
                                              _vm.confirmDialog = false
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    Yes\n                                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                            ],
                            1
                          )
                        ]
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-header" }, [
      _c("h5", [_vm._v("Search")]),
      _vm._v(" "),
      _c("a", { attrs: { href: "", id: "sidebarMenuClose" } }, [
        _c("i", { attrs: { "data-feather": "x" } })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "chart-three clearfix" }, [
      _c("div", {
        staticClass: "flot-chart ht-30",
        attrs: { id: "flotChart5" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "view-cart" }, [
        _c(
          "span",
          {
            staticClass: "close-cart",
            attrs: { "data-toggle": "collapse", "data-target": "#ViewGel" }
          },
          [_vm._v("Close")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "chart-three clearfix" }, [
      _c("div", {
        staticClass: "flot-chart ht-30",
        attrs: { id: "flotChart5" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "view-cart" }, [
        _c(
          "span",
          {
            staticClass: "close-cart",
            attrs: { "data-toggle": "collapse", "data-target": "#ViewNano" }
          },
          [_vm._v("Close")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "chart-three clearfix" }, [
      _c("div", {
        staticClass: "flot-chart ht-30",
        attrs: { id: "flotChart5" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "chart-three clearfix" }, [
      _c("div", {
        staticClass: "flot-chart ht-30",
        attrs: { id: "flotChart5" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "view-cart" }, [
        _c(
          "span",
          {
            staticClass: "close-cart",
            attrs: { "data-toggle": "collapse", "data-target": "#ViewTape" }
          },
          [_vm._v("Close")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h6",
        { staticClass: "modal-title", attrs: { id: "exampleModalLabel5" } },
        [_vm._v("Chat")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33055d30", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33055d30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Experiment/CompletionForm.vue
// module id = null
// module chunks = 